/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { buildGetRequestPayload, buildRequestPayload, shouldUseUploadDocuments } from 'lib/helper';
import apiEndpoints from '../lib/apiEndpoints';
import apiCall from './apiCall';

export const saveBusinessDetails = (payload) => {
  return apiCall({
    method: 'post',
    payload: payload,
    endpoint: apiEndpoints.SAVE_BUSINESS_DETAILS,
  });
};

export const kycVerificationCall = (payload) => {
  return apiCall({
    method: 'post',
    payload: payload,
    endpoint: apiEndpoints.KYC_VERIFICATION,
  });
};

export const publicTokenSelfServeVerificationCall = (payload) => {
  const url = `${apiEndpoints.POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION}/${payload.token}?token_type=${payload.token_type}`; 
  return apiCall({
    method: 'get',
    endpoint: url,
  });
};

export const fetchKycDetailsCall = (payload) => {
  return apiCall({
    method: 'post',
    payload: payload,
    endpoint: apiEndpoints.FETCH_KYC_DETAILS,
  });
};

export const getProductList = () => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.PRODUCTS_LISTING,
  });
};

export const postSelectedProducts = (payload) => {
  return apiCall({
    method: 'post',
    payload: payload,
    endpoint: apiEndpoints.POST_PRODUCTS_LIST_SELECTED,
  });
};

// pan and gst page api's

export const getPanAndGstDetails = (payload) =>{
return apiCall({
 method: "post",
 payload: payload,
 endpoint: apiEndpoints.PAN_AND_GST_DETAILS(payload),
});
};

export const gstValidationCall = (payload) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.GST_VALIDATION,
    payload: payload,
  });
};

export const getStatesData = (publicPayload = null)=>{
    const endpoint = publicPayload
      ? apiEndpoints.PUBLIC_STATE_DATA
      : apiEndpoints.STATES_DATA;

    const requestPayload = buildGetRequestPayload(publicPayload);

  return apiCall({
    method: 'get',
    endpoint: endpoint,
    ...(requestPayload && { query: requestPayload })
  });
};

export const getCityData = (payload) => {
  const { stateCode } = payload;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.CITIES_DATA(stateCode),
  });
};


// kyc verification api's
export const getDetailsFromDigi = (payload) =>{
  return apiCall({
    method: 'post',
    payload: payload,
    endpoint: apiEndpoints.DETAILS_FROM_DIGILOCKER,
  });
};

export const getProductListConfiguredForMerchant = (payload) => {
  const { data, mid } = payload;
  return apiCall({
    method: 'post',
    payload: data,
    endpoint: apiEndpoints.GET_PRODUCTS_LIST_SELECTED(mid),
  });
};

export const panValidationCall = (payload) => {
  const { pan } = payload;
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.PAN_VALIDATION(pan),
  });
};

export const fetchGstDetails = (payload) => {
  const { pan } = payload;
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.FETCH_GST_DETAILS(pan),
  });
};



export const bankAccountVerificationCall = (payload) => {
  const { accountNumber, ifscCode } = payload;
  return apiCall({
    method: 'post',
    payload: {
      bank_account_number: accountNumber,
      ifsc_code: ifscCode,
    },
    endpoint: apiEndpoints.SELF_SERVE_BANK_ACCOUNT_VERIFICATION,
  });
};

export const getStepDetails = (data: { cancelKey?: string } = {}) => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.SELF_SERVE_GET_STATE_OF_ONBOARDING,
    cancelKey: data?.cancelKey,
  });
};

export const selfServeSaveAndNextAPI = (data) => {
  return apiCall({
    method: 'put',
    endpoint: apiEndpoints.SELF_SERVE_SAVE_AND_NEXT,
    payload: data,
  });
};

export const autosaveStepAPI = (data) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.SELF_SERVE_AUTOSAVE,
    payload: data,
  });
};

// Sidebar step click API
export const sidebarStepClickAPI = (data: { target_step: string }) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.SIDEBAR_STEP_CLICK,
    payload: data,
  });
};

export const MccFromGst = (gst: string) => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.MCC_FROM_GST,
  });
};

export const getDigiUrl = (payload, publicPayload = null) => {
   const { pan, redirect_url, kyc_type} = payload;

    const requestPayload = {
    pan,
    redirect_url,
    kyc_type
  };

  const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_DIGILOCKER_URL
    : apiEndpoints.DIGILOCKER_URL;

    const finalPayload = buildRequestPayload(requestPayload, publicPayload);

  return apiCall({
    method: 'post',
    payload: finalPayload,
    endpoint: endpoint,
  });
};

export const getDigiDetails = (payload, publicPayload = null) => {
   const { pan, digilocker_request_id, kyc_type, is_pep, is_rpep, state_name} = payload;

    const requestPayload = {
    pan,
    digilocker_request_id,
    kyc_type,
    is_pep,
    is_rpep,
    state_name
  };

   const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_DIGILOCKER_DETAILS
    : apiEndpoints.DIGILOCKER_DETAILS;

   const finalPayload = buildRequestPayload(requestPayload, publicPayload);


  return apiCall({
    method: 'post',
    payload: finalPayload,
    endpoint: endpoint,
  });
};

export const getVideoKycUrl = (publicPayload = null) => {

  const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_VIDEO_KYC_URL
    : apiEndpoints.VIDEO_KYC_URL;

  const requestPayload = buildGetRequestPayload(publicPayload);

  return apiCall({
    method: 'get',
    endpoint: endpoint,
   ...(requestPayload && { query: requestPayload })
  });
};

export const getVideoKycStatus = (publicPayload = null) => {
   const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_VIDEO_KYC_STATUS
    : apiEndpoints.VIDEO_KYC_STATUS;
   const requestPayload = buildGetRequestPayload(publicPayload);
  return apiCall({
    method: 'get',
    endpoint: endpoint,
    ...(requestPayload && { query: requestPayload })
  });
};

export const completeVideoKycJourney = (publicPayload = null) => {
   const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_COMPLETE_VIDEO_KYC_JOURNEY
    : apiEndpoints.COMPLETE_VIDEO_KYC_JOURNEY;

    const requestPayload = buildGetRequestPayload(publicPayload);

  return apiCall({
    method: 'get',
    endpoint: endpoint,
    ...(requestPayload && { query: requestPayload })
  });
};

export const updateReviewStep = (payload) => {
  return apiCall({
    method: 'put',
    payload: payload,
    endpoint: apiEndpoints.REVIEW_UPDATE_STEP,
  });
};

export const sendOtpPdf = (payload) => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.SEND_OTP_PDF(payload),
  });
};

export const verifyOtpPdf = (payload) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.VERIFY_OTP_PDF,
    payload: payload,
  });
};

export const showPdf = (publicPayload = null) => {
    const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_SHOW_PDF
    : apiEndpoints.SHOW_PDF;

   const requestPayload = buildGetRequestPayload(publicPayload);
   return apiCall({
    method: requestPayload ? 'post' : 'get',
    endpoint: endpoint,
  ...(requestPayload ? {payload: requestPayload} : {}),
  });
};

export const showOpportunityStatus = (payload = null) => {

  const requestPayload = buildGetRequestPayload(payload);

  if(payload) {
    return apiCall({
      method: 'post',
      endpoint: apiEndpoints.PUBLIC_OPPORTUNITY_STATUS,
      query: requestPayload
    });
  } else {
    return apiCall({
      method: 'get',
      endpoint: apiEndpoints.SHOW_OPPORTUNITY_STATUS,
    });
  }
};

export const toggleEnv = (payload: { env: 'LIVE' | 'TEST' }) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.SELF_SERVE_TOGGLE,
    payload: { currEnv: payload.env },
    customOrigin: process.env.REACT_APP_TOGGLE_LIVE_DOMAIN,
  });
};


export const getCINNumberValidation = (payload: {
  cin?: string;
  llpin?: string;
}) => {
  const { cin, llpin } = payload;
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.CIN_NUMBER_VALIDATION,
    payload: {
      ...(cin && { cin_number: cin }),
      ...(llpin && { llpin }),
    },
  });
};

export const createReviewRequest = (payload) =>{
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.CREATE_REVIEW_REQUEST,
    payload: payload,
  });
};


export const deleteReviewRequest = (payload) =>{
  const { reviewRequestId } = payload;
  return apiCall({
    method: 'delete',
    endpoint: apiEndpoints.DELETE_REVIEW_REQUEST(reviewRequestId)
  });
};

export const confirmChildSelectionApi = (payload) => {
  return apiCall({
    method: 'post',
    payload: payload,
    endpoint: apiEndpoints.CONFIRM_CHILD_SELECTION,
  });
};


export const fetchUploadDocumentsApi = (publicPayload = null) =>{
  const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_FETCH_DOCUMENTS
    : apiEndpoints.FETCH_UPLOAD_DOCUMENTS;
  
  const requestPayload = buildGetRequestPayload(publicPayload);

  return apiCall({
    method: 'get',
    endpoint: endpoint,
    ...(requestPayload && { query: requestPayload }),
  });
};

export const uploadDocumentApi = (payload, publicPayload = null) => {
const { documentType, file, pci_dss_consent, removed_document_type } = payload;
  const form = new FormData();
  form.append('document_type', documentType);
  form.append('file_content', file || '');
  if (pci_dss_consent !== undefined) {
    form.append('pci_dss_consent', String(pci_dss_consent));
  }
  if (removed_document_type !== undefined) {
    form.append('removed_document_type', removed_document_type);
  }

   if (publicPayload) {
    form.append('payload', JSON.stringify(publicPayload));
  }

const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_DOCUMENTS_UPLOAD
    : apiEndpoints.DOCUMENTS_UPLOAD;

  return apiCall({
    method: 'post',
    endpoint: endpoint,
    formData: form,
  });
};

export const rejectionApi = (payload) => {
  const { messages = {} } = payload;
  const form = new FormData();

  for(const i in messages) {
    form.append(i, messages?.[i]?.value);
  }

  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.REJECTION_CLARIFICATION,
    formData: form,
  });
};

export const generateESignUrlApi = (payload, publicPayload = null) => {
  const { expected_signer_name, is_rectification } = payload;

  const requestPayload = {
    expected_signer_name,
    is_rectification
  };

    const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_GENERATE_ESIGN_URL
    : apiEndpoints.GENERATE_ESIGN_URL;

const finalPayload = buildRequestPayload(requestPayload, publicPayload);

   return apiCall({
    method: 'post',
    payload: finalPayload,
    endpoint: endpoint,
  });
};

export const getEsignStatusApi = (publicPayload = null) => {
  const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_ESIGN_STATUS
    : apiEndpoints.GET_ESIGN_STATUS;
  
  const requestPayload = buildGetRequestPayload(publicPayload);

  return apiCall({
    method: 'get',
    endpoint: endpoint,
    ...(requestPayload && { payload: requestPayload })
  });
};

export const sendEmailCompanyDirectorApi = (payload) => {
  return apiCall({
    method: 'post',
    payload: payload,
    endpoint: apiEndpoints.SEND_EMAIL_COMPANY_DIRECTOR,
  
  });
};

export const addAndUpdateBeneficiaryApi = (payload) => {
  return apiCall({
    method: 'post',
    payload: payload,
    endpoint: apiEndpoints.UPDATE_BENEFICIARY_OWNER_DETAILS,  
  
  });
};

export const resendEmailBeneficiaryApi = (payload) => {
  return apiCall({
    method: 'post',
    payload: payload,
    endpoint: apiEndpoints.RESEND_EMAIL_BENEFICIARY,
  
  });
};

export const getBeneficiaryOwnersApi = () => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_BENEFICIARY_OWNERS,
  
  });
};

export const sendEmailKycAgreementApi = (payload) => {
  return apiCall({
    method: 'post',
    payload: payload,
    endpoint: apiEndpoints.SEND_EMAIL_KYC_AGREEMENT,
  });
};

export const panValidationKycAgreement = (payload, publicPayload = null) =>{
  const { pan_number, step_name } = payload;
   const requestPayload = {
    pan_number,
    step_name,
  };

    const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_PAN_VALIDATION_KYC_AGREEMENT
    : apiEndpoints.PAN_VALIDATION_KYC_AGREEMENT;

     const finalPayload = buildRequestPayload(requestPayload, publicPayload);

  return apiCall({
    method: 'post',
    payload: finalPayload,
    endpoint: endpoint,
  });
};

export const getAgreementEsignUrlApi = (publicPayload = null, additionalData = {})=>{

 const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_AGREEMENT_ESIGN_URL
    : apiEndpoints.AGREEMENT_ESIGN_URL;

    const requestPayload = buildRequestPayload(additionalData, publicPayload);

   return apiCall({
    method: 'post',
    endpoint: endpoint,
    payload: requestPayload
  });
};

export const getDocumentEsignStatusApi = (publicPayload = {}) =>{
   const endpoint = shouldUseUploadDocuments(publicPayload)
    ? apiEndpoints.DOCUMENT_ESIGN_STATUS
    : apiEndpoints.PUBLIC_ESIGN_STATUS;

  return apiCall({
    method: 'get',
    endpoint: endpoint,
    ...(publicPayload && { query: publicPayload }),
  });
};

export const getAgreementEsignStatusApi = (publicPayload = null)=>{
   const endpoint = publicPayload 
    ? apiEndpoints.PUBLIC_AGREEMENT_ESIGN_STATUS 
    : apiEndpoints.AGREEMENT_ESIGN_STATUS;

   const requestPayload = buildGetRequestPayload(publicPayload);

  return apiCall({
    method: 'get',
    endpoint: endpoint,
    ...(requestPayload && { query: requestPayload })
  });
};

export const getDownloadReportsApi = (data) => {
  const { url, publicPayload } = data;
  const endpoint = publicPayload ? apiEndpoints.PUBLIC_DOWNLOAD_DOCUMENT_VIA_URL : apiEndpoints.DOWNLOAD_DOCUMENT_VIA_URL;
  return apiCall({
    method: 'get',
    endpoint: endpoint,
    query: publicPayload ? { docUrl: url, ...publicPayload} : { doc_url: url }
  });
};

export const sendVerificationCodeCkyc = (payload) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.SEND_VERIFICATION_CODE_CKYC,
    payload: payload,
  });
};

export const verifyCkycOtp = (payload) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.VERIFY_CKYC_OTP,
    payload: payload,
  });
};

export const downloadCkycData = (payload) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.CKYC_DOWNLOAD_DATA,
    payload: payload,
  });
};

export const mapCkycData = (payload, publicPayload = null) => {
  const {step,is_signatory_ckyc_pan_submission_consented,is_signatory_ckyc_aadhaar_submission_consented,is_pep,is_rpep,state_name,designation,signatory_name} = payload;
  const requestPayload = {
    step,
    is_signatory_ckyc_pan_submission_consented,
    is_signatory_ckyc_aadhaar_submission_consented,
    is_pep,
    is_rpep,
    state_name,
    designation,
    signatory_name
  };

  const finalPayload = buildRequestPayload(requestPayload, publicPayload);

  const endpoint = publicPayload
    ? apiEndpoints.PUBLIC_MAP_CKYC_DATA
    : apiEndpoints.MAP_CKYC_DATA;

  return apiCall({
    method: 'post',
    endpoint: endpoint,
    payload: finalPayload,
  });
};

export const updatePciDssConsentApi = () => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.PCI_DSS_CONSENT,
  });
};
